import React, { useEffect, useRef, useState } from "react";
import { Badge, Card, Col, Collapse, Form, InputGroup, Modal, Offcanvas, Row, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import { LuSend } from "react-icons/lu";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FaUser, FaUserShield } from "react-icons/fa";
import UseToggle from "../../../../../Hooks/UseToggle";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySettingControlServices } from "../../../../../APIServices/studySettingControlServices";
import FieldCancelQuery from "./FieldCancelQuery";
import FieldReOpenQuery from "./FieldReOpenQuery";
import { isHTMLIdentifier } from "../../../../../utils/universalFunction";

const FieldQueryHistory = ({
  Show,
  Hide,
  Title,
  dataEntryQueryHistory,
  tableRef,
  onMouseDown,
  queryButtonLoader,
  genarateButtonLoader,
  queryStatusButtonLoader,
  reOpenqueryButtonLoader,
  queryDataLoader,
  dataEntryQueryDiscussionLoader,
  reOpenQueryStudySubjectFormField,
  queryDiscussionStudySubjectFormField,
  generateManualQueryStatusStudySubjectFormField,
  generateManualQueryStudySubjectFormFieldDataEntry,
  getStudySubjectFormFieldQueryDiscussionDataEntry,
  setResponseMessage,
  responseMessage,
  setQuerySubject,
  querySubject,
  querySubjectType,
  setQuerySubjectType,
  setQueryMessage,
  queryMessage,
  fieldId,
  formName,
  version,
  formType,
  formFields,
  setQueryDueDate,
  queryDueDate,
  setQueryPriority,
  queryPriority,
  totalDataEntry,
  setSelectedRadioField,
  selectedRadioField,
  setReasonMessage,
  reasonMessage,
  dataEntryQueryDiscussion,
  queryType,
  setQueryType
}) => {
  const [openChatModule, setOpenChatModule] = useState("");
  const [querySubjectList, setQuerySubjectList] = useState([]);
  const [queryMessageList, setQueryMessageList] = useState([]);
  const [queryResponseList, setQueryResponseList] = useState([]);
  const [queryMessageType, setQueryMessageType] = useState("dynamic");
  const [queryResponseType, setQueryResponseType] = useState("dynamic");
  const [fieldTab, setFieldTab] = useState("");
  const [queryData, setQueryData] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const { toggle, setToggle, toggle1, setToggle1 } = UseToggle();
  const [studyTabData, setStudyTabData] = useState("");
  const AppsRef = useRef(null);
  const [openAction, setOpenAction] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenAction(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (!fieldTab) return;
    setQueryData(
      dataEntryQueryHistory?.find(
        item => (item.fieldName === fieldTab && item.queryType === queryType)
      ) || {}
    );
  }, [queryType, fieldTab, dataEntryQueryHistory]);

  useEffect(() => {
    setOpenAction(false)
    setSelectedRadioField("")
    setQuerySubject("")
    setQueryMessage("")
    setOpenChatModule("")
  }, [Show]);

  let checkFieldData = formFields?.find(item => item.id === fieldId)
  let checkEntryStatus = totalDataEntry?.find(item => item.fieldId === fieldId)

  let fieldValue;
  if (checkFieldData?.type === "date") {
    fieldValue = `${checkEntryStatus?.day ?? ''}${checkEntryStatus?.month ? `-${checkEntryStatus.month}` : ''}${checkEntryStatus?.year ? `-${checkEntryStatus.year}` : ''}`;
  } else if (checkFieldData?.type === "time") {
    fieldValue = `${checkEntryStatus?.hour ?? ''}${checkEntryStatus?.minute ? `-${checkEntryStatus.minute}` : ''}${checkEntryStatus?.second ? `-${checkEntryStatus.second}` : ''} ${checkEntryStatus?.format ? `${checkEntryStatus.format}` : ''}`;
  } else if (checkFieldData?.type === "checkbox") {
    fieldValue = (checkEntryStatus?.value || [])?.join(", ")
  } else {
    fieldValue = checkEntryStatus?.value
  }

  let selectedDataFunction = () => {
    if (!(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes")) {
      setSelectedRadioField({
        name: checkFieldData?.fieldName,
        label: checkFieldData?.fieldLabel,
        value: fieldValue
      })
    }
  }

  const checkActiveDynamicTabData = () => {
    const savedStudyTabData = JSON.parse(localStorage.getItem("studyTabs")) || [];
    let tablData = savedStudyTabData?.find(

      (item) => item.studyTabId?.includes("viewEventSchemaFormLists") && item.status === "active"
    );
    setStudyTabData(tablData?.idObject || "");
  };

  const getQuerySubjectList = async () => {
    let data = await studySettingControlServices.getQuerySubjectList();
    setQuerySubjectList(data?.data);
  };

  const getActiveQueryMessageList = async (id) => {
    let data = await studySettingControlServices.getActiveQueryMessageList(id);
    setQueryMessageList(data.data);
  };

  const getActiveQueryResponseMessageList = async (id) => {
    let data = await studySettingControlServices.getActiveQueryResponseMessageList(id);
    setQueryResponseList(data.data);
  };

  useEffect(() => {
    if (Show && dataEntryQueryHistory?.length > 0) {
      setFieldTab(dataEntryQueryHistory?.[0]?.fieldName);
      getStudySubjectFormFieldQueryDiscussionDataEntry(dataEntryQueryHistory?.[0]?.queryId)
      checkActiveDynamicTabData();
      if (dataEntryQueryHistory?.[0]?.subjectType === "dynamic") {
        getActiveQueryMessageList(dataEntryQueryHistory?.[0]?.subject)
        getActiveQueryResponseMessageList(dataEntryQueryHistory?.[0]?.subject)
      }
    }
  }, [Show, dataEntryQueryHistory]);

  useEffect(() => {
    if (Show) {
      checkActiveDynamicTabData();
    }
  }, [Show]);

  useEffect(() => {
    if (queryType === "auto") {
      setOpenAction(false)
    }
  }, [queryType]);

  useEffect(() => {
    selectedDataFunction()
    getQuerySubjectList()
  }, []);

  const getStatusBadge = (status) => {
    const statusMap = {
      "open": "danger",
      "re-open": "danger",
      "answered": "primary",
      "responded": "primary",
      "close": "success",
      "cancel": "warning",
    };
    return statusMap[status] || "secondary";
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="px-3 pt-3" ref={AppsRef}>
            <div className="hstack justify-content-between mb-3">
              <h6 style={{ fontSize: 14 }} className="fw-bold">{queryType === "manual" ? "Manual Query" : "Auto Query"}</h6>
              <InputGroup className="w-auto">
                <button onClick={() => setQueryType("manual")} className={`updateProfile ${queryType === "manual" ? "activee" : ""}`}>
                  Manual Query
                </button>
                <button onClick={() => setQueryType("auto")} className={`updateProfile ${queryType === "auto" ? "activee" : ""}`}>
                  Auto Query
                </button>
              </InputGroup>
            </div>
            {((StudyMode === "DBP Mode" || StudyMode?.startsWith("SDV")) && queryType === "manual") &&
              <div className="w-25 mb-3">
                <button
                  onClick={() => { setOpenAction(!openAction); selectedDataFunction() }}
                  className={`updateProfile`}
                >
                  <span>Generate Query</span>
                </button>
              </div>
            }
            {(dataEntryQueryHistory?.length > 0 || openAction) &&
              <Card className="mb-2 border bg-light">
                <Card.Body className="p-3">
                  <Row className="mb-2">
                    <Col xs={4}>
                      <small className="text-muted fw-bold">Site</small>
                      <div style={{ fontSize: "13px" }}>{studyTabData.siteName}</div>
                    </Col>
                    <Col xs={4}>
                      <small className="text-muted fw-bold">Subject</small>
                      <div style={{ fontSize: "13px" }}>{studyTabData.subjectName}</div>
                    </Col>
                    <Col xs={4}>
                      <small className="text-muted fw-bold">Event</small>
                      <div style={{ fontSize: "13px" }}>{studyTabData.eventName} {studyTabData?.timePointLabel && `(${studyTabData?.timePointLabel})`}</div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={4}>
                      <small className="text-muted fw-bold">Form</small>
                      <div style={{ fontSize: "13px" }}>{formName}</div>
                    </Col>
                    <Col xs={4}>
                      <small className="text-muted fw-bold">Version</small>
                      <div style={{ fontSize: "13px" }}>v{version}</div>
                    </Col>
                    <Col xs={4}>
                      <small className="text-muted fw-bold">Form Type</small>
                      <div className="text-capitalize" style={{ fontSize: "13px" }}>{formType}</div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            }
            <Collapse in={openAction}>
              <div className="mb-2">
                <Card className="mb-2 border bg-light p-2">
                  <Row>
                    {(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes") &&
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="fw-bold mb-1">
                          Fields{" "}
                          <abbr title="Required" className="text-danger">
                            *
                          </abbr>
                        </Form.Label>
                        <Form.Check
                          type="radio"
                          label={
                            <>
                              {isHTMLIdentifier(checkFieldData?.fieldLabel || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: checkFieldData?.fieldLabel,
                                  }}
                                />
                              ) : (
                                checkFieldData?.fieldLabel
                              )}{" "}
                              ({checkFieldData?.fieldName})
                            </>
                          }
                          name="queryField"
                          disabled={checkEntryStatus?.queryStatus === "open"}
                          checked={
                            selectedRadioField?.name === checkFieldData?.fieldName
                          }
                          onChange={(e) =>
                            setSelectedRadioField({
                              name: checkFieldData?.fieldName,
                              label: checkFieldData?.fieldLabel,
                              value: fieldValue,
                            })
                          }
                        />
                        {(checkFieldData?.fieldUnit === "yes") && (
                          <Form.Check
                            type="radio"
                            label={`${checkFieldData?.fieldUnitLabel} (${checkFieldData?.fieldUnitName})`}
                            name="queryField"
                            disabled={!checkEntryStatus?.unit || checkEntryStatus?.unitQueryStatus === "open"}
                            checked={selectedRadioField?.name === checkFieldData?.fieldUnitName}
                            onChange={(e) => setSelectedRadioField({ name: checkFieldData?.fieldUnitName, label: checkFieldData?.fieldUnitLabel, value: checkEntryStatus?.unit })}
                          />
                        )}
                        {(checkFieldData?.customFieldRemark === "yes") && (
                          <Form.Check
                            type="radio"
                            label={`${checkFieldData?.customFieldRemarkLabel} (${checkFieldData?.customFieldRemarkName})`}
                            name="queryField"
                            disabled={!checkEntryStatus?.valueRemark || checkEntryStatus?.queryValueRemarkStatus === "open"}
                            checked={selectedRadioField?.name === checkFieldData?.customFieldRemarkName}
                            onChange={(e) => setSelectedRadioField({ name: checkFieldData?.customFieldRemarkName, label: checkFieldData?.customFieldRemarkLabel, value: checkEntryStatus?.valueRemark })}
                          />
                        )}
                        {checkEntryStatus?.type.startsWith("custom") &&
                          <>
                            {(checkFieldData?.referenceRangeLowerLimit === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.referenceRangeLowerLimitLabel} (${checkFieldData?.referenceRangeLowerLimitName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.referenceRangeLowerLimit || checkEntryStatus?.referenceRangeLowerLimitQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.referenceRangeLowerLimitName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.referenceRangeLowerLimitName, label: checkFieldData?.referenceRangeLowerLimitLabel, value: checkEntryStatus?.referenceRangeLowerLimit })
                                }
                              />
                            )}
                            {(checkFieldData?.referenceRangeUpperLimit === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.referenceRangeUpperLimitLabel} (${checkFieldData?.referenceRangeUpperLimitName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.referenceRangeUpperLimit || checkEntryStatus?.referenceRangeUpperLimitQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.referenceRangeUpperLimitName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.referenceRangeUpperLimitName, label: checkFieldData?.referenceRangeUpperLimitLabel, value: checkEntryStatus?.referenceRangeUpperLimit })
                                }
                              />
                            )}
                            {(checkFieldData?.referenceRangeIndicator === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.referenceRangeIndicatorLabel} (${checkFieldData?.referenceRangeIndicatorName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.referenceRangeIndicator || checkEntryStatus?.referenceRangeIndicatorQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.referenceRangeIndicatorName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.referenceRangeIndicatorName, label: checkFieldData?.referenceRangeIndicatorLabel, value: checkEntryStatus?.referenceRangeIndicator })
                                }
                              />
                            )}
                            {(checkFieldData?.clinicalSignificance === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.clinicalSignificanceLabel} (${checkFieldData?.clinicalSignificanceName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.clinicalSignificance || checkEntryStatus?.clinicalSignificanceQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.clinicalSignificanceName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.clinicalSignificanceName, label: checkFieldData?.clinicalSignificanceLabel, value: checkEntryStatus?.clinicalSignificance })
                                }
                              />
                            )}
                            {(checkFieldData?.customRemark === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.customRemarkLabel} (${checkFieldData?.customRemarkName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.remark || checkEntryStatus?.remarkQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.customRemarkName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.customRemarkName, label: checkFieldData?.customRemarkLabel, value: checkEntryStatus?.remark })
                                }
                              />
                            )}
                          </>
                        }
                      </Form.Group>
                    }
                    {(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes") ?
                      <>
                        <Form.Group as={Col} md={6} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Priority{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Select
                            onChange={(e) => setQueryPriority(e.target.value)}
                            style={{ fontSize: 12 }}
                            className="br3"
                            value={queryPriority}
                          >
                            <option value="low">Low</option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                            <option value="critical">Critical</option>
                          </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} md={6} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Due Date{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Control
                            className="br3"
                            min={new Date().toISOString().split("T")[0]}
                            onChange={(e) => setQueryDueDate(e.target.value)}
                            value={queryDueDate}
                            type="date"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <div className="hstack gap-2">
                            <Form.Label className="fw-bold mb-1">
                              Subject{" "}
                              <abbr title="Required" className="text-danger">
                                *
                              </abbr>
                            </Form.Label>
                            <Badge onClick={() => { setQuerySubjectType(querySubjectType === "dynamic" ? "custom" : "dynamic"); setQuerySubject("") }} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{querySubjectType === "dynamic" ? "custom" : "dynamic"}</Badge>
                          </div>
                          {querySubjectType === "dynamic" ?
                            <Form.Select
                              onChange={(e) => { setQuerySubject(e.target.value); getActiveQueryMessageList(e.target.value) }}
                              style={{ fontSize: 12 }}
                              className="br3"
                              value={querySubject}
                            >
                              <option value="">Select Message</option>
                              {querySubjectList?.map((item => (
                                <option value={item?._id}>
                                  {item?.subject}
                                </option>
                              )))}
                            </Form.Select>
                            :
                            <Form.Control
                              className="br3"
                              onChange={(e) => { setQuerySubject(e.target.value); getActiveQueryMessageList(e.target.value) }}
                              value={querySubject}
                              placeholder="Subject"
                              type="text"
                            />
                          }
                        </Form.Group>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <div className="hstack gap-2">
                            <Form.Label className="fw-bold mb-1">
                              Message{" "}
                              <abbr title="Required" className="text-danger">
                                *
                              </abbr>
                            </Form.Label>
                            <Badge onClick={() => setQueryMessageType((querySubjectType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic")} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{(querySubjectType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic"}</Badge>
                          </div>
                          {(queryMessageType === "dynamic" && querySubjectType === "dynamic") ?
                            <Form.Select
                              onChange={(e) => setQueryMessage(e.target.value)}
                              style={{ fontSize: 12 }}
                              className="br3"
                              value={queryMessage}
                            >
                              <option value="">Select Message</option>
                              {queryMessageList?.map((item => (
                                <option value={item?.message}>
                                  {item?.message}
                                </option>
                              )))}
                            </Form.Select>
                            :
                            <Form.Control
                              className="br3"
                              onChange={(e) => setQueryMessage(e.target.value)}
                              value={queryMessage}
                              placeholder="Message"
                              as="textarea"
                            />
                          }
                        </Form.Group>
                      </>
                      :
                      <>
                        <Form.Group as={Col} md={6} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Priority{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Select
                            onChange={(e) => setQueryPriority(e.target.value)}
                            style={{ fontSize: 12 }}
                            className="br3"
                            disabled={checkEntryStatus?.queryStatus === "open"}
                            value={queryPriority}
                          >
                            <option value="low">Low</option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                            <option value="critical">Critical</option>
                          </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} md={6} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Due Date{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Control
                            className="br3"
                            min={new Date().toISOString().split("T")[0]}
                            onChange={(e) => setQueryDueDate(e.target.value)}
                            value={queryDueDate}
                            disabled={checkEntryStatus?.queryStatus === "open"}
                            type="date"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <div className="hstack gap-2">
                            <Form.Label className="fw-bold mb-1">
                              Subject{" "}
                              <abbr title="Required" className="text-danger">
                                *
                              </abbr>
                            </Form.Label>
                            {checkEntryStatus?.queryStatus !== "open" &&
                              <Badge onClick={() => { setQuerySubjectType(querySubjectType === "dynamic" ? "custom" : "dynamic"); setQuerySubject("") }} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{querySubjectType === "dynamic" ? "custom" : "dynamic"}</Badge>
                            }
                          </div>
                          {querySubjectType === "dynamic" ?
                            <Form.Select
                              onChange={(e) => { setQuerySubject(e.target.value); getActiveQueryMessageList(e.target.value) }}
                              style={{ fontSize: 12 }}
                              className="br3"
                              disabled={checkEntryStatus?.queryStatus === "open"}
                              value={querySubject}
                            >
                              <option value="">Select Message</option>
                              {querySubjectList?.map((item => (
                                <option value={item?._id}>
                                  {item?.subject}
                                </option>
                              )))}
                            </Form.Select>
                            :
                            <Form.Control
                              className="br3"
                              onChange={(e) => { setQuerySubject(e.target.value); getActiveQueryMessageList(e.target.value) }}
                              value={querySubject}
                              disabled={checkEntryStatus?.queryStatus === "open"}
                              placeholder="Subject"
                              type="text"
                            />
                          }
                        </Form.Group>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <div className="hstack gap-2">
                            <Form.Label className="fw-bold mb-1">
                              Message{" "}
                              <abbr title="Required" className="text-danger">
                                *
                              </abbr>
                            </Form.Label>
                            {checkEntryStatus?.queryStatus !== "open" &&
                              <Badge onClick={() => setQueryMessageType((querySubjectType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic")} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{(querySubjectType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic"}</Badge>
                            }
                          </div>
                          {(queryMessageType === "dynamic" && querySubjectType === "dynamic") ?
                            <Form.Select
                              onChange={(e) => setQueryMessage(e.target.value)}
                              style={{ fontSize: 12 }}
                              className="br3"
                              disabled={checkEntryStatus?.queryStatus === "open"}
                              value={queryMessage}
                            >
                              <option value="">Select Message</option>
                              {queryMessageList?.map((item => (
                                <option value={item?.message}>
                                  {item?.message}
                                </option>
                              )))}
                            </Form.Select>
                            :
                            <Form.Control
                              className="br3"
                              onChange={(e) => setQueryMessage(e.target.value)}
                              value={queryMessage}
                              disabled={checkEntryStatus?.queryStatus === "open"}
                              placeholder="Message"
                              as="textarea"
                            />
                          }
                        </Form.Group>
                      </>
                    }
                  </Row>
                  <div className="text-end">
                    <button
                      disabled={!queryPriority || !queryDueDate || !queryMessage || !querySubject || selectedRadioField?.name === 0 || genarateButtonLoader}
                      onClick={generateManualQueryStudySubjectFormFieldDataEntry}
                      className="updateProfile"
                      style={{ fontSize: 12 }}
                    >
                      {genarateButtonLoader ? <div className="hstack gap-2">
                        <Spinner size="sm" /> Generating...
                      </div>
                        : " Generate Now"
                      }

                    </button>
                  </div>
                </Card>
              </div>
            </Collapse>
          </div>
          {queryDataLoader ?
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <PageLoader />
            </div>
            : dataEntryQueryHistory?.length === 0 && !StudyMode?.startsWith("SDV") ?
              <div
                className="hstack justify-content-center"
                style={{ height: "calc(100vh - 44px)" }}
              >
                <NoDataFoundTable MSG={"Field query history not found!"} />
              </div>
              : dataEntryQueryHistory?.length > 0 &&
              <div className="px-3">
                {dataEntryQueryHistory?.length > 0 &&
                  <InputGroup className="w-auto mb-2">
                    {dataEntryQueryHistory?.map((item, index) => (
                      <button key={index} onClick={() => { setFieldTab(item?.fieldName); getStudySubjectFormFieldQueryDiscussionDataEntry(item?.queryId) }} className={`updateProfile ${fieldTab === item?.fieldName ? "activee" : ""}`}>
                        {isHTMLIdentifier(queryData?.fieldLabel || "") ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: queryData?.fieldLabel,
                            }}
                          />
                        ) : (
                          queryData?.fieldLabel
                        )}
                      </button>
                    ))}
                  </InputGroup>
                }
                {fieldTab &&
                  <>
                    <Card className="mb-2 border bg-light">
                      <Card.Body className="p-3">
                        <Row>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Field Label (Name)</small>
                            <div style={{ fontSize: "13px" }}>
                              {isHTMLIdentifier(queryData?.mainFieldLabel || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: queryData?.mainFieldLabel,
                                  }}
                                />
                              ) : (
                                queryData?.mainFieldLabel
                              )} ({queryData?.mainFieldName})
                            </div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Sub Field Label (Name)</small>
                            <div style={{ fontSize: "13px" }}>
                              {isHTMLIdentifier(queryData?.fieldLabel || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: queryData?.fieldLabel,
                                  }}
                                />
                              ) : (
                                queryData?.fieldLabel
                              )} ({queryData?.fieldName})
                            </div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Sub Field Value</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryData?.fieldValue?.startsWith("https://") ? (
                                <Badge
                                  onClick={() =>
                                    window.open(queryData.fieldValue, "_blank", "noopener,noreferrer")
                                  }
                                  bg="primary-subtle" className="CP text-primary" style={{ borderRadius: 3, fontSize: 10 }}>
                                  View File
                                </Badge>
                              ) : (
                                queryData?.fieldValue
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Category</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryData?.subjectMessage}
                            </div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Status</small>
                            <div>
                              <Badge bg={queryData?.status === "open" ? "danger-subtle" : queryData?.status === "cancel" ? "warning-subtle" : "success-subtle"} className={`mb-1 ${queryData?.status === "open" ? "text-danger" : queryData?.status === "cancel" ? "text-warning" : "text-success"} text-capitalize CP`} style={{ fontSize: 9 }}>{queryData?.status}</Badge>
                            </div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Priority</small>
                            <div>
                              <Badge bg={(queryData?.priority === "critical" || queryData?.priority === "high") ? "danger-subtle" : queryData?.priority === "medium" ? "warning-subtle" : "success-subtle"} className={`mb-1 ${(queryData?.priority === "critical" || queryData?.priority === "high") ? "text-danger" : queryData?.priority === "medium" ? "text-warning" : "text-success"} text-capitalize CP`} style={{ fontSize: 9 }}>{queryData?.priority}</Badge>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card className="mb-2 border bg-light">
                      <Card.Body className="p-3">
                        <Row>
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Raised by</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryData?.generatedByName}
                            </div>
                          </Col>
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Assigned to</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryData?.assignedToName}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Due Date</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryData?.dueDate}
                            </div>
                          </Col>
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Due Age</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryData?.dueAge}
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    {queryType === "manual" ?
                      <Card className="mb-2 border bg-light p-2">
                        <Form.Group as={Col} md={12} className="mb-2">
                          <div className="hstack justify-content-between">
                            <div className="hstack gap-2">
                              <Form.Label className="fw-bold mb-1">
                                Response Message{" "}
                                <abbr title="Required" className="text-danger">
                                  *
                                </abbr>
                              </Form.Label>
                              {!(queryStatusButtonLoader || queryData?.status !== "open") &&
                                <Badge onClick={() => setQueryResponseType((queryResponseType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic")} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{(queryResponseType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic"}</Badge>
                              }
                            </div>
                            {((StudyMode === "DBP Mode" || StudyMode?.startsWith("SDV")) && queryData?.status === "open") &&
                              <div className="hstack gap-2">
                                <Badge onClick={() => { if (!queryStatusButtonLoader) generateManualQueryStatusStudySubjectFormField(queryData?.queryId, "close") }} bg={queryStatusButtonLoader ? "secondary" : "success"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                                  {queryStatusButtonLoader === "close" ? <div className="hstack gap-2">
                                    <Spinner style={{ height: 10, width: 10 }} size="sm" /> Closing...
                                  </div>
                                    : "Close Query"
                                  }
                                </Badge>
                                <Badge onClick={() => { if (!queryStatusButtonLoader) setToggle() }} bg={queryStatusButtonLoader ? "secondary" : "danger"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                                  {queryStatusButtonLoader === "cancel" ? <div className="hstack gap-2">
                                    <Spinner style={{ height: 10, width: 10 }} size="sm" /> Cancelling...
                                  </div>
                                    : "Cancel Query"
                                  }
                                </Badge>
                              </div>
                            }
                            {((StudyMode === "DBP Mode" || StudyMode?.startsWith("SDV")) && queryData?.status !== "open") &&
                              <Badge onClick={setToggle1} bg={reOpenqueryButtonLoader ? "secondary" : "danger"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                                {reOpenqueryButtonLoader ? <div className="hstack gap-2">
                                  <Spinner style={{ height: 10, width: 10 }} size="sm" /> Re-Opening...
                                </div>
                                  : "Re-Open Query"
                                }
                              </Badge>
                            }
                          </div>
                          {(queryMessageType === "dynamic" && queryResponseType === "dynamic") ?
                            <Form.Select
                              onChange={(e) => setResponseMessage(e.target.value)}
                              style={{ fontSize: 12 }}
                              className="br3"
                              disabled={queryStatusButtonLoader || queryData?.status !== "open"}
                              value={responseMessage}
                            >
                              <option value="">Select Message</option>
                              {queryResponseList?.map((item => (
                                <option value={item?.response}>
                                  {item?.response}
                                </option>
                              )))}
                            </Form.Select>
                            :
                            <Form.Control
                              className="br3"
                              disabled={queryStatusButtonLoader || queryData?.status !== "open"}
                              onChange={(e) => setResponseMessage(e.target.value)}
                              value={responseMessage}
                              placeholder="Response Message"
                              as="textarea"
                            />
                          }
                        </Form.Group>
                        <div className="text-end">
                          <button
                            disabled={!responseMessage || queryButtonLoader || queryStatusButtonLoader || queryData?.status !== "open"}
                            onClick={() => queryDiscussionStudySubjectFormField(queryData?.queryId)}
                            className="updateProfile"
                            style={{ fontSize: 12 }}
                          >
                            {queryButtonLoader ? <div className="hstack gap-2">
                              <Spinner size="sm" /> Sending...
                            </div>
                              : " Send Now"
                            }

                          </button>
                        </div>
                      </Card>
                      :
                      <div className="hstack justify-content-end">
                        {((StudyMode === "DBP Mode" || !StudyMode?.startsWith("SDV")) && queryData?.status === "open") &&
                          <div className="hstack gap-2">
                            <Badge onClick={() => { if (!queryStatusButtonLoader) generateManualQueryStatusStudySubjectFormField(queryData?.queryId, "close") }} bg={queryStatusButtonLoader ? "secondary" : "success"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                              {queryStatusButtonLoader === "close" ? <div className="hstack gap-2">
                                <Spinner style={{ height: 10, width: 10 }} size="sm" /> Closing...
                              </div>
                                : "Close Query"
                              }
                            </Badge>
                          </div>
                        }
                      </div>
                    }
                    <div>
                      <h6 style={{ fontSize: 14 }} className="fw-bold mb-3">Query History & Audit</h6>
                      {dataEntryQueryDiscussionLoader ?
                        <div
                          className="hstack justify-content-center"
                          style={{ height: "calc(100vh - 580px)" }}
                        >
                          <PageLoader />
                        </div> :
                        dataEntryQueryDiscussion.map((item, index) => (
                          <div key={index} className="mb-3">
                            <div className="d-flex align-items-start gap-3">
                              <div className="d-flex flex-column align-items-center">
                                <div style={{
                                  width: "12px", height: "12px", borderRadius: "50%",
                                  background: (item.status === "answered" || item.status === "responded") ? "#0d6efd" :
                                    item.status === "close" ? "#198754" :
                                      item.status === "cancel" ? "#d19916" :
                                        (item.status === "open" || item.status === "re-open") ? "#ed0000" :
                                          "#787878",
                                  marginTop: "4px"
                                }}>
                                </div>
                                {index < dataEntryQueryDiscussion?.length - 1 && (
                                  <div style={{ width: "2px", height: "40px", background: "#dee2e6", margin: "4px 0" }}></div>
                                )}
                              </div>
                              <div style={{ flex: 1 }}>
                                <div className="hstack gap-2 flex-wrap">
                                  <span className="fw-bold text-capitalize">{item.actionStatus === "cancel" ? "cancelled" : item.actionStatus === "close" ? "closed" : item?.actionStatus}</span>
                                  <Badge bg={`${getStatusBadge(item.status)}-subtle`} className={`text-${getStatusBadge(item.status)} rounded-1 text-capitalize`} style={{ fontSize: 9 }}>
                                    {item.status === "cancel" ? "cancelled" : item.status === "close" ? "closed" : item?.status}
                                  </Badge>
                                  <small className="text-muted ms-auto">{item.commentedByName}, {item.commentedDT}</small>
                                </div>
                                <Card className="mt-2 border bg-light p-2 w-100">
                                  <div className="mt-1" style={{ fontSize: "13px", color: "#212529" }}>
                                    {item.comment}
                                  </div>
                                </Card>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                }
              </div>
          }
        </Offcanvas.Body>
      </Offcanvas>

      <FieldCancelQuery
        Show={!toggle}
        Hide={setToggle}
        queryStatusButtonLoader={queryStatusButtonLoader}
        generateManualQueryStatusStudySubjectFormField={generateManualQueryStatusStudySubjectFormField}
        Title="Cancel Query"
        setReasonMessage={setReasonMessage}
        reasonMessage={reasonMessage}
        queryData={queryData}
      />

      <FieldReOpenQuery
        Show={!toggle1}
        Hide={setToggle1}
        reOpenqueryButtonLoader={reOpenqueryButtonLoader}
        reOpenQueryStudySubjectFormField={reOpenQueryStudySubjectFormField}
        Title="Re-Open Query"
        setReasonMessage={setReasonMessage}
        reasonMessage={reasonMessage}
        queryData={queryData}
      />
    </>
  );
};

export default FieldQueryHistory;